import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D80027",
  d: "m21.52 19.307-7.306-7.306 7.307-7.307a12.1 12.1 0 0 0-2.214-2.214l-7.306 7.307L4.694 2.48a12 12 0 0 0-2.213 2.214L9.787 12 2.48 19.307a12.1 12.1 0 0 0 2.214 2.214l7.307-7.307 7.306 7.307a12.1 12.1 0 0 0 2.214-2.214"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFDA44",
  d: "m9.914 3.653 2.087.522 2.087-.522V1.879l-.835.417-1.252-1.252-1.252 1.252-.835-.417z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D80027",
  d: "M9.914 3.653v1.304c0 1.598 2.087 2.087 2.087 2.087s2.087-.49 2.087-2.087V3.653z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }